module.exports = __webpack_public_path__ + "static/media/MHRP89N1000.6a20fca3.svg";